import React from "react";
import { useTranslation } from "react-i18next";
import { getImage } from "../../services/ImageService";

export function CustomerSection() {
    const { t } = useTranslation();
    return (
        <div
            id="customers"
            className="bg-[#FAFAFA] flex flex-col items-center justify-center px-16 py-12 md:p-24 md:px-32"
        >
            <div className="w-full text-lg text-center font-bold max-w-screen-lg mb-12">
                {t("customer-section-text")}
            </div>
            <div className="flex items-center justify-center xl:justify-between flex-wrap 2xl:max-w-screen-lg">
                <img
                    src={getImage("storaenso_logo")}
                    className="select-none mr-12 w-1/4 lg:w-1/6 min-w-72"
                    draggable={false}
                />
                <img
                    src={getImage("sveaskog_logo")}
                    className="select-none mr-12 w-1/4 lg:w-1/6 min-w-72"
                    draggable={false}
                />
                <img
                    src={getImage("sodra_logo")}
                    className="select-none mx-6 w-1/4 lg:w-1/6 min-w-72"
                    draggable={false}
                />
                <img
                    src={getImage("norra_logo")}
                    className="select-none ml-6 w-1/4 lg:w-1/6 min-w-72"
                    draggable={false}
                />
                <img
                    src={getImage("skogssallskapet_logo")}
                    className="select-none ml-12 w-1/4 lg:w-1/6 min-w-72"
                    draggable={false}
                />
            </div>
        </div>
    );
}
